import { render, staticRenderFns } from "./v20d7010.vue?vue&type=template&id=2dd01ae8&"
import script from "./v20d7010.vue?vue&type=script&lang=js&"
export * from "./v20d7010.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports